import React from "react";
import styled from "styled-components";
import { TitleText } from "../../../ui/Text";
import { EditIcon } from "../../../assets/svg/EditIcon";
import { DeleteIcon } from "../../../assets/svg/DeleteIcon";

interface Iprops {
  title: string;
  isEdit?: boolean;
  setisModalOpen?: any;
  count?: any;
  handleDelete?: any;
  setId?: any;
}

const Header = ({
  title,
  isEdit,
  setisModalOpen,
  count,
  handleDelete,
}: Iprops) => {
  return (
    <HeaderContainer>
      {<CountItem>{count}</CountItem>}

      <TitleText>{title}</TitleText>
      <TitleText style={{ fontSize: "12px", marginLeft: "auto" }}>
        <span onClick={() => setisModalOpen(true)}>
          Add new <span style={{ color: "#01A8CE" }}>+</span>
        </span>
      </TitleText>

      {isEdit ? (
        <Actions>
          <TitleText
            style={{ fontSize: "12px" }}
            onClick={() => setisModalOpen(true)}
          >
            <EditIcon /> Edit
          </TitleText>
          <TitleText
            style={{ fontSize: "12px", marginLeft: "13em" }}
            onClick={handleDelete}
          >
            <DeleteIcon /> Delete
          </TitleText>
        </Actions>
      ) : null}
    </HeaderContainer>
  );
};

export default Header;

const HeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 0.5fr 3fr 2fr;
  align-items: center;
  /* justify-content: space-between; */
  padding: 0 1.3em;
  border-bottom: 1px solid rgba(55, 81, 255, 0.1);
`;

const CountItem = styled.span`
  font-weight: semi-bold;
  font-size: 1.125em;
  color: #01A8CE;
  padding: 0.4em 0.6em;
  margin-right: 0.5em;
  align-items: center;
  border-radius: 25%;
  width: fit-content;
  border: 1px solid rgba(76, 92, 251, 0.1);
`;

const Actions = styled.span`
  display: flex;
  flex-direction: row;
  grid-column: 1 / span 3;
  width: 150%;
`;
